// src/store/orderSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchOrderHistory } from '../api/orderApi';

export const fetchOrders = createAsyncThunk(
  'orders/fetchOrders',
  async (user_key, { rejectWithValue }) => {
    console.log('fetchOrders called with user_key:', user_key); // 调试
    try {
      const response = await fetchOrderHistory({ user_key });
      console.log('fetchOrders response:', response); // 调试
      return response.data.get_order_history; // 返回嵌套的订单数组
    } catch (error) {
      console.error('fetchOrders error:', error);
      return rejectWithValue(error.response?.data || 'Failed to fetch orders');
    }
  }
);

const initialState = {
  orders: [],
  status: 'idle',
  error: null,
};

const orderSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    clearOrders(state) {
      state.orders = [];
      state.status = 'idle';
      state.error = null;
    },
    toggleOrder(state, action) {
      const out_trade_no = action.payload;
      state.orders = state.orders.map(order =>
        order.out_trade_no === out_trade_no ? { ...order, expanded: !order.expanded } : order
      );
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrders.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.orders = action.payload.map(order => ({
          ...order,
          expanded: false,
        }));
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Something went wrong';
      });
  },
});

export const { clearOrders, toggleOrder } = orderSlice.actions;
export default orderSlice.reducer;